// WCAG 2.1 AA 调色板（contrast-checked）
//
// 选色原则：
// - text:* 用于文字 → 与白底必须 ≥ 4.5:1（normal）/ ≥ 3:1（large 18pt+）
// - on*    用于"在该背景上的文字色"
// - graphic:* UI 组件/图形 → ≥ 3:1
//
// 旧 vs 新（供 grep 替换参考）：
//   #FF7043 (text 2.74)  → text.primary  = #D2451E  (4.59 ✓)
//   #FF7043 (bg)         → bg.primary    = #FF7043  (保留作背景)
//   #999    (2.85)       → text.tertiary = #595959  (7.0 ✓)
//   #bbb    (1.92)       → graphic.muted = #595959 / 文字 #737373 (4.74)
//   #5DD5C4+#fff (1.78)  → bg.success + onSuccess = #0E7C6B (浅绿底深绿字)
//   #FAAD14+#fff (1.90)  → bg.warning + onWarning = #7A4F00
//   #FF6B6B+#fff (2.78)  → bg.danger  + onDanger  = #B91C1C
export const colors = {
	// 主品牌色
	primary: {
		bg: '#FF7043',           // 大背景／实心按钮
		text: '#D2451E',         // 文字色（4.59 ✓）— 旧 #FF7043 改这个
		hover: '#C5400E',
		soft: '#FFF7E6',         // 浅橙背景
		softBorder: '#FFD591',
	},
	// 文字色
	text: {
		primary: '#1F1F1F',      // 主体（21:1）
		secondary: '#595959',    // 次要（7.0:1）— 旧 #666/#999 都用这个
		tertiary: '#737373',     // 三级文字（4.74:1）— 旧 #bbb 都用这个
		disabled: '#A6A6A6',     // 禁用（仅 large text）
		inverse: '#FFFFFF',
	},
	// 状态色（用于 badge text + soft bg 组合）
	status: {
		// passed - 浅绿底+深绿字
		successText: '#0E7C6B',  // 深 mint，可在白/浅绿底
		successBg: '#D7F5EE',
		successSolid: '#10B981', // 实心强调（仅 bg 用）
		// pending - 浅黄底+棕字
		warningText: '#7A4F00',
		warningBg: '#FFF7DD',
		warningSolid: '#F59E0B',
		// rejected - 浅红底+深红字
		dangerText: '#B91C1C',
		dangerBg: '#FFE5E5',
		dangerSolid: '#DC2626',
	},
	// UI 图形（边框、icon）
	graphic: {
		border: '#E5E7EB',
		divider: '#F0F0F0',
		muted: '#595959',        // 旧 #999/#bbb 灰图形
	},
	// 背景
	bg: {
		page: '#F5F5F5',
		card: '#FFFFFF',
		soft: '#FAFAFA',
	},
} as const;

/** focus-visible 通用 outline 样式 */
export const focusRing: React.CSSProperties = {
	outline: '2px solid #1677FF',
	outlineOffset: 2,
	borderRadius: 4,
};

/** 应用到 a11yButton 通用样式 */
export const a11yButtonReset: React.CSSProperties = {
	background: 'none',
	border: 0,
	padding: 0,
	margin: 0,
	font: 'inherit',
	color: 'inherit',
	textAlign: 'start',
	cursor: 'pointer',
	width: '100%',
};
